"use strict";

// remove the SY2024-2025 prefersSpa flag
localStorage.removeItem("prefersSpa");

$(function () {
    if (enableSinglePageApp) {
        if (singlePageApp.optIn) {
            // The login page stays here on opt-in sites; the choice is acted on by the
            // landing page the user reaches after signing in.
            $("#UseNewExperience")
                .prop("checked", singlePageApp.prefersSpa())
                .on("change", function () {
                    singlePageApp.setPrefersSpa(this.checked);
                });
        } else {
            if (singlePageApp.prefersSpa()) {
                location.href = '../spa';
            }

            $(".changeSite").on("click", () => {
                singlePageApp.setPrefersSpa(true);
            });
        }
    }

    $(".input-validation-error")
        .next(".field-validation-error")
        .addClass("glyphicon glyphicon-remove form-control-feedback")
        .attr("title", function() {
            return $(this).html();
        })
        .empty()
        .closest(".form-group")
        .addClass("has-error has-feedback");
});
